import {
  getCardData,
  getClientCounts,
  getSTBCounts,
  getClientTrends,
  getClientsData,
  getStockItemDetails,
  getverifyusername,
  getgeneratekey,
  getverifyemail,
} from "@/http/dashboard";
export default {
  namespaced: true,
  state: {
    dashboard: {},
    isLoading: false,
    clientCounts: {},
    stbCounts: {},
    carddata: {},
    userDetails: {},
    clientTrendsDetail: {},
    officeDetails: [],
    stockItemDetail: [],
    username: [],
    email: [],
  },
  actions: {
    async setDashBoardData({ commit }) {
      const resp = await getCardData();
      commit("SET_DASHBOARD_DATA", resp.data);
      return resp.data;
    },
    async setUserDetails({ commit }) {
      const resp = await getUserDetails();
      commit("SET_USER_DETAILS", resp.data);
      return resp;
    },
    async setverifyusername({ commit }, username) {
      const resp = await getverifyusername(username);
      commit("SET_VERIFY_USERNAME", resp.data);
      return resp;
    },
    async setverifyemail({ commit }, email) {
      const resp = await getverifyemail(email);
      commit("SET_VERIFY_EMAIL", resp.data);
      return resp;
    },
    async setgeneratekey(_, email) {
      return await getgeneratekey(email);
    },
    async setClientTrendsDetails({ commit }, data) {
      const resp = await getClientTrends(data.office, data.time);
      commit("SET_CLIENT_TRENDS_DETAILS", resp.data);
      return resp;
    },
    async setOfficeDetails({ commit }) {
      const resp = await getClientsData();
      commit("SET_OFFICE_DETAILS", resp.data.officeOptions);
      return resp;
    },
    async setClientCounts({ commit }) {
      const resp = await getClientCounts();
      commit("SET_CLIENT_COUNTS", resp.data);
      return resp;
    },
    async setStockItemDetails({ commit }, id) {
      const resp = await getStockItemDetails(id);
      commit("SET_STOCK_ITEM_DETAILS", resp.data);
      return resp.data;
    },
    async setSTBCounts({ commit }) {
      const response = await getSTBCounts();
      commit("SET_STB_COUNTS", response.data);
      return response.data;
    },
  },
  mutations: {
    SET_DASHBOARD_DATA(state, payload) {
      state.carddata = payload;
    },
    SET_USER_DETAILS(state, payload) {
      state.userDetails = payload;
    },
    SET_CLIENT_COUNTS(state, payload) {
      state.clientCounts = payload;
    },
    SET_STB_COUNTS(state, payload) {
      state.stbCounts = payload;
    },
    SET_CLIENT_TRENDS_DETAILS(state, payload) {
      state.clientTrendsDetail = payload;
    },
    SET_OFFICE_DETAILS(state, payload) {
      state.officeDetails = payload;
    },
    SET_STOCK_ITEM_DETAILS(state, payload) {
      state.stockItemDetail = payload;
    },
    SET_VERIFY_USERNAME(state, payload) {
      state.username = payload;
    },
    SET_VERIFY_EMAIL(state, payload) {
      state.email = payload;
    },
  },
  getters: {
    GetClientCounts(state) {
      return state.clientCounts;
    },
    GetSTBCounts(state) {
      return state.stbCounts;
    },
  },
};
